import { useIonAlert, useIonToast } from '@ionic/react'
import { alertCircleSharp, checkmarkCircleSharp, closeCircleSharp } from 'ionicons/icons'

const useMessages = () => {
  const [presentToast] = useIonToast()

  const [presentAlert] = useIonAlert()

  const toastMessage = (message: string, duration: number, position: any, type: string) => {
    let toastStyle
    if (type === 'success') toastStyle = 'toast-success'
    else if (type === 'message') toastStyle = 'toast-message'
    else toastStyle = 'toast-error'

    let icon
    if (type === 'success') icon = checkmarkCircleSharp
    else if (type === 'message') icon = alertCircleSharp
    else icon = closeCircleSharp

    presentToast({
      message,
      duration,
      cssClass: toastStyle,
      position: 'bottom',
      buttons: [
        {
          text: '',
          role: 'cancel',
          cssClass: 'close-alert-btn'
        }
      ],
      icon
    })
  }

  const modalMessage = (
    header: string,
    message: string,
    proceedHandler: VoidFunction,
    cancelMsg?: string,
    cancelHandler?: VoidFunction
  ) => {
    presentAlert({
      header,
      message,
      cssClass: 'alert-procedure',
      buttons: [
        {
          text: 'ABANDONAR',
          role: 'proceed',
          cssClass: 'alert-btn-leave',
          handler: proceedHandler
        },
        {
          text: cancelMsg ?? 'CONTINUAR TRÁMITE',
          role: 'cancel',
          cssClass: 'alert-btn-proceed',
          handler: cancelHandler
        }
      ]
    })
  }

  return {
    toastMessage,
    modalMessage
  }
}

export default useMessages
